
import { ComputedRef, defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { computed } from "@vue/reactivity";
import { UserGeneralStatistics } from "../../../../../domain/entities/entities";
import { dispatchError } from "../../../utils/error_handling";
import { formattedDuration } from "../../mixins";
import { wrapLoading } from "../../../utils/wrap_loading";

export default defineComponent({
  name: "GeneralStatistics",
  setup() {
    const store = useStore();
    onMounted(async () => {
      try {
        await wrapLoading(async () => {
          await loadGeneralStatistics();
        });
      } catch (e) {
        console.log("[onMounted] Error ", e);
        await dispatchError(e);
      }
    });

    const loadGeneralStatistics = async () => {
      try {
        await store.dispatch("userProfile_module/loadGeneralStatistics");
      } catch (e) {
        console.log("[loadTeams] Error ", e);
        throw e;
      }
    };

    const generalStatistics: ComputedRef<UserGeneralStatistics | null> = computed(
      () => store.getters["userProfile_module/generalStatistics"]
    );

    return {
      formattedDuration,
      generalStatistics,
    };
  },
});
